import React, { Suspense } from 'react';
import { Loader, Text } from '@marvelapp/ui';
var QRCode = React.lazy(function () { return import('qrcode.react'); });
export default function SidebarQRCode() {
    return (React.createElement(Suspense, { fallback: React.createElement(Loader, { size: 24 }) },
        React.createElement(QRCode, { bgColor: "#ffffff", fgColor: "#000000", includeMargin: false, level: "L", renderAs: "svg", size: 128, value: window.location.href }),
        React.createElement(Text, { fontSize: 2, marginTop: 3, px: 4, textAlign: "center" }, "Point your phone's camera to the QR code above to open this prototype on your device.")));
}
